// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__W5B5F","dragIcon":"SortableItem_dragIcon__2rWEK","disabled":"SortableItem_disabled__2F_KA"};